const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const datesAreOnSameDay = (first, second) => first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();
export const incrementDate = (date, increment) => {
    const d = new Date(date);
    d.setUTCDate(d.getUTCDate() + increment);
    return d;
};
export const formatTimestamp = (timestamp) => {
    const today = new Date();
    const basicTimeFormat = timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    // If it's today return the time only
    if (datesAreOnSameDay(today, timestamp)) {
        return basicTimeFormat;
    }
    // If it's yesterday return "Yesterday" + time
    const yesterday = incrementDate(today, -1);
    if (datesAreOnSameDay(yesterday, timestamp)) {
        return `Yesterday ${basicTimeFormat}`;
    }
    // otherwise return day date month hh:mm
    const dow = weekdays[timestamp.getDay()] || '';
    const mon = months[timestamp.getMonth()] || '';
    return `${dow} ${timestamp.getDate()} ${mon} ${basicTimeFormat}`;
};
//# sourceMappingURL=helpers.js.map